import { ExplicitSelectionButton } from '@yes.technology/react-toolkit'
import useFetchSuggestions from '../../../hooks/useFetchSuggestions'
import { useEffect } from 'react'
import { ActivityModel } from 'types/shared'
import { ActivityInputProps } from '../Activity.types'
import { MULTISELECTION_SEPARATOR } from 'utils/constants'

export type ActivityExplicitMultiselectionProps = {
  id: string
  parentPath: string[]
  label: string
  value: ActivityModel['value']
  filteraction?: string
  onChange: ActivityInputProps['handleChange']
  disabled?: boolean
} & Pick<
  React.ComponentProps<typeof ExplicitSelectionButton>,
  'id' | 'label' | 'options' | 'optionLabelsPosition' | 'direction' | 'required'
>

const ActivityExplicitMultiselection = ({
  id,
  parentPath,
  label,
  value,
  filteraction,
  options = [],
  onChange,
  direction,
  optionLabelsPosition,
  required,
  disabled
}: ActivityExplicitMultiselectionProps) => {
  const selectedOptions = {
    des:
      (typeof value === 'object' &&
        value?.des?.split(MULTISELECTION_SEPARATOR)) ||
      [],
    id:
      (typeof value === 'object' &&
        value?.id?.split(MULTISELECTION_SEPARATOR)) ||
      []
  }
  const { suggestions, fetchSuggestions } = useFetchSuggestions({
    parentPath,
    filteraction,
    showLoading: true
  })

  useEffect(() => {
    if (!filteraction) {
      return
    }

    fetchSuggestions('.*')
  }, [fetchSuggestions, filteraction])
  const finalOptions = options.length ? options : suggestions

  const getCheckedOptions = () => {
    let selectedOption: (typeof options)[0] | undefined

    return selectedOptions.des.reduce(
      (accumulator: Record<string, true>, current) => {
        selectedOption = finalOptions.filter(
          (option) => option.des === current
        )[0]

        if (selectedOption) {
          accumulator[selectedOption.uuid] = true
        }

        return accumulator
      },
      {}
    )
  }

  const handleChange = ({ des, uuid }: { des: string; uuid: string }) => {
    const index = selectedOptions.id.indexOf(uuid)

    if (index === -1) {
      selectedOptions.des.push(des)
      selectedOptions.id.push(uuid)
    } else {
      selectedOptions.des.splice(index, 1)
      selectedOptions.id.splice(index, 1)
    }

    onChange({
      id: selectedOptions.id.join(MULTISELECTION_SEPARATOR),
      des: selectedOptions.des.join(MULTISELECTION_SEPARATOR)
    })
  }

  return (
    <ExplicitSelectionButton
      heightClass='regular'
      label={label}
      selectionType='multiselection'
      options={finalOptions}
      direction={direction}
      optionLabelsPosition={optionLabelsPosition}
      checkedOption={getCheckedOptions()}
      id={id}
      required={required}
      disabled={disabled}
      onChange={handleChange}
    />
  )
}

export default ActivityExplicitMultiselection
